import styled from 'styled-components';

const Layer = styled.div`
  position: fixed;
  left: 50%;
  top: 0%;
  white-space: normal;
  transform: ${({ position }) => `translateX(${-1 * position}%) translateX(${-50 + position}vw)`};
  z-index: auto;
  min-width: ${(props) => props.minWidth && `${props.minWidth}px`};
  pointer-events: ${(props) => props.ignoreEvents && 'none'};
`;

export default Layer;



// WEBPACK FOOTER //
// ./src/components/Parallax/ParallaxLayer/ParallaxLayer.js